import { render, staticRenderFns } from "./VesselViewData.vue?vue&type=template&id=102805dc&scoped=true&"
import script from "./VesselViewData.vue?vue&type=script&lang=js&"
export * from "./VesselViewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102805dc",
  null
  
)

export default component.exports